/**
 * Lightweight grouping container — renders a titled subsection (Allowances,
 * Satin Details, etc.) with its children laid out in a responsive grid.
 *
 * Props:
 *   title — subsection heading text (uppercase, slate-400)
 *   testId — data-testid for the wrapper
 *   children — typically <StyleSelect> nodes
 *   columns — Tailwind grid-cols class string, defaults to 2/3/4 responsive
 */
export default function StyleSubSection({
  title,
  testId,
  children,
  columns = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
}) {
  return (
    <div className="mt-3 pt-3 border-t border-white/5" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-wider text-slate-400 mb-2">
        {title}
      </p>
      <div className={`grid gap-2 ${columns}`}>{children}</div>
    </div>
  );
}
